export default {
  HOME_PAGE: '/',
  SEND_AUTH_CODE: '/send-code',
  ENTER_CODE: '/code',
  PRE_SCREEN_INSRUCTIONS: '/instructions',
  CREATE_ACCOUNT: '/create-account',
  QUESTIONAIRE: '/questionnaire',
  APPROVED: '/approved',
  HIGH_RISK: '/dispo-1',
  LOW_RISK: '/dispo-2',
  CLEAR_CACHE: '/refresh',
  SIGN_OUT: '/sign-out',
  TERMS: '/terms-of-use'
};
